export default {
  'menu.welcome': 'Welcome',
  'menu.more-blocks': 'More Blocks',
  'menu.home': 'Home',
  'menu.admin': 'Admin',
  'menu.admin.sub-page': 'Sub-Page',
  'menu.login': 'Login',
  'menu.register': 'Register',
  'menu.register-result': 'Register Result',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': 'Analysis',
  'menu.dashboard.monitor': 'Monitor',
  'menu.dashboard.workplace': 'Workplace',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Form',
  'menu.form.basic-form': 'Basic Form',
  'menu.form.step-form': 'Step Form',
  'menu.form.step-form.info': 'Step Form(write transfer information)',
  'menu.form.step-form.confirm': 'Step Form(confirm transfer information)',
  'menu.form.step-form.result': 'Step Form(finished)',
  'menu.form.advanced-form': 'Advanced Form',
  'menu.list': 'List',
  'menu.list.table-list': 'Search Table',
  'menu.list.basic-list': 'Basic List',
  'menu.list.card-list': 'Card List',
  'menu.list.search-list': 'Search List',
  'menu.list.search-list.articles': 'Search List(articles)',
  'menu.list.search-list.projects': 'Search List(projects)',
  'menu.list.search-list.applications': 'Search List(applications)',
  'menu.profile': 'Profile',
  'menu.profile.basic': 'Basic Profile',
  'menu.profile.advanced': 'Advanced Profile',
  'menu.result': 'Result',
  'menu.result.success': 'Success',
  'menu.result.fail': 'Fail',
  'menu.exception': 'Exception',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Trigger',
  'menu.account': 'Account',
  'menu.account.center': 'Account Center',
  'menu.account.settings': 'Account Settings',
  'menu.account.trigger': 'Trigger Error',
  'menu.account.logout': 'Logout',
  'menu.editor': 'Graphic Editor',
  'menu.editor.flow': 'Flow Editor',
  'menu.editor.mind': 'Mind Editor',
  'menu.editor.koni': 'Koni Editor',
  'menu.Base': 'Base',
  'menu.Base.GameList': 'Games',
  'menu.Base.Optimization': 'Optimization',
  'menu.Base.Optimization.IAP': 'In-app Products',
  'menu.Base.Optimization.Level': 'Level',
  'menu.Base.Organization': 'Organization',
  'menu.Base.Organization.UserManagement': 'User Management',
  'menu.Base.Organization.Token': 'Token',
  'menu.Settings': 'Settings',
  'menu.Game': 'Game Management',
  'menu.Game.Overview': 'Overview',
  'menu.Game.Economy': 'Economy',
  'menu.Game.Economy.BalanceByDate': 'Balance By Date',
  'menu.Game.Economy.BalanceByLatestLevel': 'Balance By Latest Level',
  'menu.Game.Report': 'Report',
  'menu.Game.Report.BalanceByDate': 'Balance By Date',
  'menu.Game.Report.BalanceByLatestLevel': 'Balance By Latest Level',
  'menu.Game.Report.LevelMonitoring': 'Level Monitoring',
  'menu.Game.Report.UserDropByLevelGroup': 'User Drop By Level Group',
  'menu.Game.Report.ChurnContributeByLevel': 'Churn Contribute By Level',
  'menu.Game.SocialServices': 'Social Services',
  'menu.Game.SocialServices.Users': 'Users',
  'menu.Game.SocialServices.Mail': 'Mail',
  'menu.Game.SocialServices.Leaderboard': 'Leaderboard',
  'menu.Game.StoreManagement': 'Store Management',
  'menu.Game.StoreManagement.InAppPurchase': 'In-app Purchase',
  'menu.Game.StoreManagement.InAppEvent': 'In-app Event',
  'menu.Game.CrossPromotion': 'Cross Promotion',
  'menu.Game.CrossPromotion.Creatives': 'Creatives',
  'menu.Game.CrossPromotion.Ads': 'Ads',
  'menu.Game.Setting': 'Settings',
  'menu.Game.Setting.Items': 'Items',
  'menu.Game.Setting.Analytics': 'Analytics',
  'menu.Game.Setting.AutoBuild': 'Auto Build',
  'menu.Game.Setting.Advanced': 'Advanced',
  'menu.Game.SocialServices.Team': 'Team',
  'menu.Game.GameEvents': 'Game Events',
  'menu.Game.GameEvents.Overview': 'Overview',
  'menu.Game.GameEvents.MissionPass': 'Mission Pass',
};
